import { useState, useEffect } from 'react';

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // En ambiente de tests (sin window.matchMedia), retornar false por defecto
    if (!window.matchMedia) {
      return;
    }

    const mediaQuery = window.matchMedia(query);

    // Set inicial
    setMatches(mediaQuery.matches);

    // Listener para cambios
    const handleChange = (e) => setMatches(e.matches);

    // Usar addEventListener para mejor compatibilidad
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }
    // Fallback para navegadores antiguos
    else {
      mediaQuery.addListener(handleChange);
      return () => mediaQuery.removeListener(handleChange);
    }
  }, [query]);

  return matches;
};

export default useMediaQuery;
